<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2h2" id="heading_id_2">Contents</h2>
<p class="left"><a href="#/Text/06_9781614230076_Foreword">Foreword, by Martin Perschler</a></p>
<p class="left"><span href="#/Text/07_9781614230076_Preface" title="Link target outside of Sample">Preface</span></p>
<p class="left"><span href="#/Text/08_9781614230076_Acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="left"><span href="#/Text/09_9781614230076_Prologue" title="Link target outside of Sample">Prologue. April 19, 1861, Baltimore, Maryland</span></p>
<p class="lefta"><span href="#/Text/10_9781614230076_CH01" title="Link target outside of Sample">I. Baltimore on the Eve of the Pratt Street Riot: April 1, 1861</span></p>
<p class="left"><span href="#/Text/11_9781614230076_CH02" title="Link target outside of Sample">II. A Prelude to Baltimore’s Bloody Riot: April 12, 1861, Fort Sumter, Charleston, South Carolina</span></p>
<p class="left"><span href="#/Text/12_9781614230076_CH03" title="Link target outside of Sample">III. Trying to Prevent a Riot: April 15 to April 18, 1861</span></p>
<p class="left"><span href="#/Text/13_9781614230076_CH04" title="Link target outside of Sample">IV. A Plan to Assassinate Lincoln</span></p>
<p class="left"><span href="#/Text/14_9781614230076_CH05" title="Link target outside of Sample">V. The Civil War’s First Blood: Pratt Street, Baltimore, April 19, 1861</span></p>
<p class="left"><span href="#/Text/15_9781614230076_CH06" title="Link target outside of Sample">VI. More Violence: Baltimore Is Cut Off from the North, April 19–27, 1861</span></p>
<p class="left"><span href="#/Text/16_9781614230076_CH07" title="Link target outside of Sample">VII. Lincoln Declares Martial Law: April 27 to May 13, 1861</span></p>
<p class="left"><span href="#/Text/17_9781614230076_CH08" title="Link target outside of Sample">VIII. Some Questionable Arrests</span></p>
<p class="left"><span href="#/Text/18_9781614230076_CH09" title="Link target outside of Sample">IX. The Story of Habeas Corpus</span></p>
<p class="left"><span href="#/Text/19_9781614230076_CH10" title="Link target outside of Sample">X. Baltimore: A Prisoner of Its Geography</span></p>
<p class="left"><span href="#/Text/20_9781614230076_CH11" title="Link target outside of Sample">XI. Lincoln’s Last Ride: The Aftermath of the Pratt Street Riot, April 21, 1865, to Present</span></p>
<p class="left"><span href="#/Text/21_9781614230076_Appendix" title="Link target outside of Sample">Appendix I. The Lives of Some of the Participants After the Pratt Street Riot and the Civil War</span></p>
<p class="left"><a href="#/Text/22_9781614230076_Appendix1">Appendix II. Pratt Street Riot Markers</a></p>
<p class="left"><span href="#/Text/23_9781614230076_Sources" title="Link target outside of Sample">Sources and Materials Used in Research</span></p>
<p class="left"><span href="#/Text/24_9781614230076_AuthorNote" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_9781614230076_Contents.vue?4b26bdf1